import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { TrendingUp } from 'lucide-react';

function severityStyle(severity) {
  const s = (severity || '').toLowerCase();
  if (s === 'critical') {
    return 'border-[hsl(0,84%,60%)]/40 bg-[hsl(0,84%,60%)]/10';
  }
  if (s === 'high') {
    return 'border-[hsl(24,94%,56%)]/40 bg-[hsl(24,94%,56%)]/10';
  }
  return 'border-[hsl(188,100%,55%)]/40 bg-[hsl(188,100%,55%)]/10';
}

export function PredictiveInsightsBanner({ insights = [], compact = false }) {
  if (!insights?.length) return null;

  return (
    <div className={cn('space-y-2', compact ? '' : 'mt-2')} data-testid="predictive-insights-banner">
      {insights.map((insight) => (
        <div
          key={insight.id || insight.title}
          className={cn('rounded-lg border p-3', severityStyle(insight.severity))}
        >
          <div className="flex items-start gap-2">
            <TrendingUp className="w-4 h-4 text-[hsl(188,100%,55%)] flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-2 mb-1">
                <p className="text-sm font-medium">{insight.title}</p>
                <Badge variant="outline" className="text-[10px] px-1.5 py-0 border-border/60">
                  {insight.confidence} confidence
                </Badge>
                {insight.severity && (
                  <Badge variant="outline" className="text-[10px] px-1.5 py-0 border-border/60">
                    {insight.severity}
                  </Badge>
                )}
              </div>
              <p className="text-xs text-muted-foreground leading-relaxed">{insight.message}</p>
              {!compact && insight.recommended_action && (
                <p className="text-xs text-foreground/80 mt-2">
                  <span className="font-medium">Action:</span> {insight.recommended_action}
                </p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
